import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { callAPI } from "utils/API";

export const CprHandler = () => {
    const navigate = useNavigate();
    const [searchParams, _] = useSearchParams();

    const saveCprNumberFromSession = async () => {
        const sessionId = searchParams.get("sessionId")
        const saveCprResponse = await callAPI("/cpr/saveCprFromSession", "POST", {
                body: {
                    sessionId: sessionId,
                }
            }
        );
        if (saveCprResponse && !saveCprResponse.error ) {
            navigate('/')
        } else {
            handleError()
        }
    }

    const handleError = () => {
        // In case of error the user is just redirected to the front page
        // and can try the MitID flow again
        navigate('/')
    }

    useEffect(() => {
        saveCprNumberFromSession()
    }, [])

    return (
        <></>
    )
}





